import { css } from 'styled-components'
import { media } from '../breakpoints'

// Standard page card (white rounded box): 90px side margins on desktop,
// stepped down on smaller screens.
export const responsivePageShell = css`
  ${media.desktop`
    margin: 24px 24px 0;
  `}

  ${media.tablet`
    margin: 16px 12px 0;
    padding: 20px 16px 40px;
  `}
`

// Centered auth card (login / forgot / set password): the hr stretches
// edge-to-edge by compensating for the card's horizontal padding.
export const responsiveAuthCard = css`
  ${media.mobile`
    width: calc(100vw - 24px);
    padding: 20px 24px 40px;

    hr{
      width: calc(100% + 48px);
      transform: translateX(-24px);
    }
  `}
`

// Horizontal filter/toolbar rows: side-by-side on desktop,
// stacked full-width controls on phones.
export const responsiveFilterBar = css`
  display: flex;
  flex-wrap: wrap;

  ${media.mobile`
    > * {
      width: 100%;
    }

    .react-datepicker-wrapper {
      width: 100%;
    }
  `}
`

// "Export CSV" style inline action shared by Stats and UserStats.
export const exportButton = css`
  .export-btn {
    color: #3E5573;
    font-size: 13px;
    display: flex;
    gap: 5px;
    align-items: center;
    cursor: pointer;
    white-space: nowrap;

    svg {
      width: 11px;
      height: 15px;
      path {
        fill: #3E5573;
      }
    }
  }

  .export-btn:hover {
    color: #FBB106;
    svg {
      path {
        fill: #FBB106;
      }
    }
  }
`
